
import * as CustomSelect from "vanilla-js-dropdown";

const Dropdown = {

  el: {
    select: document.getElementById("dropdown-select"),
  },

  init: () => {

    if (Dropdown.el.select) {
      const simpleSelect = new CustomSelect({
        elem: Dropdown.el.select,
      });
    }

  },

};

export default Dropdown;
